import React from 'react';
import Highcharts from 'highcharts/highcharts.src.js';
import HighchartsReact from 'highcharts-react-official';
import { plotOptions, credits, responsiveOptions } from './defaultOptions';

type AreaChartPropsType = HighchartsReact.Props & {
	series?: Record<string, any>;
};

const AreaChart: React.FC<AreaChartPropsType> = ({
	series,
	options,
	...props
}) => {
	const chartOptions = {
		chart: {
			type: 'area',
			lineWidth: 1
		},
		tooltip: {
			split: true
		},
		plotOptions: plotOptions,
		marginLeft: 0,
		marginRight: 0,
		spacingLeft: 0,
		credits: credits,
		responsive: responsiveOptions,
		series: series,
		...options,
	};

	const chartRef = React.useRef<any>();

	React.useEffect(() => {
		if (chartRef && chartRef.current && chartRef.current.chart) {
			chartRef.current.chart.reflow();
		}
	}, [series]);

	return (
		<HighchartsReact
			ref={chartRef}
			highcharts={Highcharts}
			options={chartOptions}
			containerProps={{ style: { height: '100%', width: '100%' } }}
			{...props}
		/>
	);
};
export default AreaChart;
